import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList, BarChart, Bar } from "recharts";
import { Box, Paper, Typography, Select, MenuItem, Divider } from "@mui/material";
import { getReportChartReserveDay } from "../../redux/handlers/report/getReportChartReserveDay.handler";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
export function ReportReserveDay() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(new Date()), 2), selectedMonth = _useState[0], setSelectedMonth = _useState[1]; // เปลี่ยนเป็น Date object
    var _useState1 = _sliced_to_array(useState([]), 2), dataChart = _useState1[0], setDataChart = _useState1[1];
    var getReportChartReserveDayReducer = useAppSelector(function(state) {
        return state.getReportChartReserveDayReducer;
    });
    // Load data
    useEffect(function() {
        dispatch(getReportChartReserveDay({
            month: moment(selectedMonth).format("YYYY-MM")
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        selectedMonth
    ]);
    useEffect(function() {
        setIsLoading(getReportChartReserveDayReducer.isFetching);
        if (getReportChartReserveDayReducer.data) {
            var _getReportChartReserveDayReducer_data;
            setDataChart(getReportChartReserveDayReducer === null || getReportChartReserveDayReducer === void 0 ? void 0 : (_getReportChartReserveDayReducer_data = getReportChartReserveDayReducer.data) === null || _getReportChartReserveDayReducer_data === void 0 ? void 0 : _getReportChartReserveDayReducer_data.data);
        }
    }, [
        getReportChartReserveDayReducer
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "card card-st-3 mb-3",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body px-xl-3",
            children: [
                /*#__PURE__*/ _jsxs(Box, {
                    sx: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(Typography, {
                            fontSize: 16,
                            fontWeight: "bold",
                            sx: {
                                textAlign: "center",
                                flex: 1
                            },
                            children: [
                                "กราฟสะสมใบจองตามสถานะรายวัน",
                                /*#__PURE__*/ _jsx("br", {}),
                                /*#__PURE__*/ _jsx("span", {
                                    style: {
                                        fontSize: 14,
                                        fontWeight: 400
                                    },
                                    children: moment(selectedMonth).locale("th").format("MMMM YYYY")
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                ml: "auto"
                            },
                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                selected: selectedMonth,
                                onChange: function(date) {
                                    return setSelectedMonth(date);
                                },
                                dateFormat: "MM/yyyy",
                                showMonthYearPicker: true,
                                className: "form-control body1",
                                placeholderText: "เลือกเดือน",
                                customInput: /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    style: {
                                        padding: "8px 16px",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        background: "white",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        width: "140px"
                                    },
                                    children: moment(selectedMonth).format("MM/YYYY")
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Divider, {
                    sx: {
                        my: 2
                    }
                }),
                /*#__PURE__*/ _jsx(ResponsiveContainer, {
                    width: "100%",
                    height: 350,
                    children: /*#__PURE__*/ _jsxs(BarChart, {
                        data: dataChart,
                        children: [
                            /*#__PURE__*/ _jsx(CartesianGrid, {
                                strokeDasharray: "3 3",
                                stroke: "#ccc"
                            }),
                            /*#__PURE__*/ _jsx(XAxis, {
                                dataKey: "date",
                                tick: {
                                    fontSize: 12
                                },
                                label: {
                                    // value: "วันที่",
                                    position: "insideBottom",
                                    offset: -5
                                }
                            }),
                            /*#__PURE__*/ _jsx(YAxis, {
                                tick: {
                                    fontSize: 12
                                }
                            }),
                            /*#__PURE__*/ _jsx(Tooltip, {
                                labelFormatter: function(label) {
                                    return "วันที่ ".concat(label);
                                }
                            }),
                            /*#__PURE__*/ _jsx(Legend, {
                                verticalAlign: "bottom"
                            }),
                            /*#__PURE__*/ _jsx(Bar, {
                                dataKey: "count",
                                name: "จำนวนใบจอง",
                                fill: "#4b77ca",
                                children: /*#__PURE__*/ _jsx(LabelList, {
                                    dataKey: "count",
                                    position: "top",
                                    fontSize: 12
                                })
                            }),
                            /*#__PURE__*/ _jsx(Bar, {
                                dataKey: "net",
                                name: "มูลค่าใบจอง",
                                fill: "#f48138",
                                children: /*#__PURE__*/ _jsx(LabelList, {
                                    dataKey: "net",
                                    position: "top",
                                    fontSize: 12,
                                    formatter: function(value) {
                                        return value.toFixed(2);
                                    }
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
